import { Component, OnDestroy, AfterViewInit, Input, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { forwardRef } from "@angular/core";
import 'tinymce/tinymce';
import 'tinymce/themes/modern';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';

declare var tinymce: any;

export const TINYMCE_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TinyMce),
  multi: true
};
@Component({
  selector: 'tinymce',
  template: `<textarea #tinyMceTextArea [ngStyle]="{'height.px': height+40 }"></textarea>`,
  providers: [TINYMCE_VALUE_ACCESSOR]
})
export class TinyMce implements AfterViewInit, OnDestroy, ControlValueAccessor {

  //Placeholders for the callbacks which are later providesd
  //by the Control Value Accessor
  private onTouchedCallback: () => void;
  private onChangeCallback: (_: any) => void;

  @Input() height: number = 200;
  @Input() placeholder: string = '';
  @Output() initialized: EventEmitter<void> = new EventEmitter<void>();

  private editor;
  private editorInitialized: boolean = false;

  @ViewChild('tinyMceTextArea') textarea: ElementRef;
  
  ngAfterViewInit() {
    
    const _this = (this);

    tinymce.init({
      target: this.textarea.nativeElement,
      toolbar: 'bold italic underline | bullist numlist | link',
      language: 'nl',
      language_url: 'assets/translations/tinymce_nl.js',
      menubar: false,
      height: _this.height,
      plugins: 'link, lists',
      resize: true,
      statusbar: false,
      branding: false,
      default_link_target: "_blank",
      link_assume_external_targets: true,
      target_list: false,
      link_title: false,
      paste_as_text: true,
      invalid_elements: 'h1,h2,h3,h4,h5,h6,hr,div,span,blockquote',
      skin_url: 'assets/tinymce-skins/lightgray',
      content_style: "html, body { font-family: 'Nunito Sans', sans-serif; font-size: 15px; } p { margin-top:0; margin-bottom: 1em }",
      setup: function (editor) {
        _this.editor = editor;
        editor.on('init', () => {
          _this.editorInitialized = true;
          _this.initialized.emit();         
        });
        
        editor.on('change', function () {
          if(_this.onChangeCallback) _this.onChangeCallback(editor.getContent());
        });

        editor.on('blur', function () {
					if(_this.onTouchedCallback) _this.onTouchedCallback();
        });
        
      }
    });
  }

  private getEditorAsync(){
    return new Promise((resolve) => {
      if(this.editorInitialized) {
        resolve(this.editor);
      }
      else {
        this.initialized.subscribe(()=>{
          resolve(this.editor);
        })
      }
    });
  }

  //From ControlValueAccessor interface
  writeValue(value: string) { 
    if(typeof value !== 'string') value = '';
    
    this.getEditorAsync().then((editor: any) => {
      editor.setContent(value);
    });
  }
  
  setFocus():void {
    this.editor.execCommand('mceFocus',false);
  }
  
  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  ngOnDestroy() {
    tinymce.remove(this.editor);
  }
  
}



// WEBPACK FOOTER //
// ./src/partials/tiny-mce/tiny-mce.ts